import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable, Injector } from '@angular/core';
import { take } from 'rxjs';

import { LightboxComponent } from './lightbox.component';
import { LightboxImage, LightboxImageToken } from './lightbox-image';

@Injectable()
export class LightboxService {

  private overlayRef: OverlayRef;

  constructor(
    private readonly overlay: Overlay,
    private readonly injector: Injector
  ) {
  }

  public open(lightboxImage: LightboxImage) {
    this.overlayRef = this.createOverlayRef();
    this.overlayRef.attach(this.lightboxComponentPortal(lightboxImage));

    this.overlayRef.backdropClick().pipe(take(1)).subscribe(() => this.close());
  }

  public close() {
    this.overlayRef.detach();
  }

  private createOverlayRef(): OverlayRef {
    const positionStrategy = this.overlay.position().global().centerHorizontally().centerVertically();

    return this.overlay.create({
      maxWidth: '95vw',
      maxHeight: '95vh',
      hasBackdrop: true,
      scrollStrategy: this.overlay.scrollStrategies.block(),
      positionStrategy
    });
  }

  private lightboxComponentPortal(lightboxImage: LightboxImage) {
    return new ComponentPortal(LightboxComponent, null, Injector.create({
      parent: this.injector,
      providers: [
        {provide: LightboxImageToken, useValue: lightboxImage}
      ]
    }));
  }

}
